<div class="apreciacioGravetat">  
  <table>
    <thead>
      <tr>
        <th>{{'apreciacio_gravetat.conjunt_observacions' | translate}}</th>
        <td>
          <label>{{'apreciacio_gravetat.gravetat' | translate}}</label>
          <app-ajuda id="ajuda_gravetat" titol="{{'apreciacio_gravetat.gravetat' | translate}}">
            <ul>
              <li>
                <strong>{{'apreciacio_gravetat.ajuda_label_lleu' | translate}}:</strong> {{'apreciacio_gravetat.ajuda_lleu' | translate}}
              </li>
              <li>
                <strong>{{'apreciacio_gravetat.ajuda_label_moderada' | translate}}:</strong> {{'apreciacio_gravetat.ajuda_moderada' | translate}}
              </li>
              <li>
                <strong>{{'apreciacio_gravetat.ajuda_label_greu' | translate}}:</strong> {{'apreciacio_gravetat.ajuda_greu' | translate}}        
              </li>
            </ul>
          </app-ajuda>
        </td>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let conjunt of conjuntsSeleccionats">
        <tr *ngIf="conjunt.observacions != null && conjunt.observacions.length > 0">
          <td>
            <ul>
              <li>
                <label>{{conjunt.descripcio}}</label>
                <ul>
                  <li *ngFor="let observacio of conjunt.observacions">{{observacio.descripcio}}</li>
                </ul>
              </li>
            </ul>
          </td>
          <td>
            <select [(ngModel)]="conjunt.idGravetat">
              <option [ngValue]="0" hidden>{{'apreciacio_gravetat.trieu_gravetat' | translate}}</option>
              <option *ngFor="let gravetat of gravetats" [ngValue]="gravetat.id">{{gravetat.descripcio}}</option>
            </select>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<div class="button-bar">
  <button class="main" (click)="goToPrevStep()"><i class="fas fa-angle-left prev" aria-hidden></i> {{'globals.anterior' | translate}}</button>
  <button class="main" (click)="goToNextStep()">{{'globals.seguent' | translate}} <i class="fas fa-angle-right next" aria-hidden></i></button>
</div>

<vn-modal id="errors" title="{{'globals.revisar_camps' | translate}}" movible>
  <ng-container>{{'apreciacio_gravetat.camps_obligatoris' | translate}}</ng-container>
  <div class="button-bar">
    <button type="button" class="main" (click)="modal.close()">{{'globals.tancar' | translate}}</button>
  </div>
</vn-modal>